export default __webpack_public_path__ + "static/media/userdetailsEllipse.881e79e6.svg";